import { Control, FieldValues, UseFormReset, UseFormSetValue } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { TFuncKey } from 'i18next';

import { FilterGroup, RegisterType } from 'types';

import { Headline } from 'components/Headline';

import { useFilters } from './Filters.hooks';
import * as S from './Filters.styles';

type FiltersProps = {
  filters: FilterGroup[];
  onSubmit: () => void;
  type?: TFuncKey;
  reset?: UseFormReset<FieldValues>;
  register: RegisterType;
  defaultParams?: URLSearchParams;
  isLoading?: boolean;
  setValue: UseFormSetValue<FieldValues>;
  children?: React.ReactNode;
  control?: Control;
};

const defaultProps: Partial<FiltersProps> = {
  control: undefined,
  children: undefined,
  type: undefined,
  isLoading: false,
  reset: undefined,
  defaultParams: undefined,
};

export function Filters(props: FiltersProps): React.ReactElement {
  const {
    filters,
    type,
    register,
    onSubmit,
    control,
    reset,
    children,
    defaultParams,
    setValue,
    isLoading,
  } = {
    ...defaultProps,
    ...props,
  };
  const { filtersIntoComponents } = useFilters(
    filters,
    register,
    onSubmit,
    setValue,
    defaultParams,
    reset,
    isLoading,
    control
  );

  const { t } = useTranslation();

  return (
    <S.Container>
      <S.Header>
        <Headline scale="xl" color="blackLight" fontWeight="normal" tag="h3">
          {t('common.search')} {type ? String(t(type)) : null}
        </Headline>

        {children || null}
      </S.Header>

      <S.Filters>{filtersIntoComponents}</S.Filters>
    </S.Container>
  );
}
